/**
 * Converts an ISO date string from the backend to a Date object.
 * Parses the date parts to create a Date in UTC (not local time).
 * Returns null if the date string is null or invalid.
 */
export function formatResponseDate(date: string | null): Date | null {
  if (!date) {
    return null;
  }

  const dateString = date.split("T")[0];
  const dateParts = dateString.split("-");
  const year = +dateParts[0];
  // Months are zero-based in JavaScript
  const month = +dateParts[1] - 1;
  const day = +dateParts[2];
  return new Date(year, month, day, 0, 0, 0, 0);
}

/**
 * Converts a Date object to an ISO string at the start of the day in UTC.
 * Returns null if the date is null.
 * Used when submitting dates to the backend.
 */
export function formatDateToStartOfDay(date: Date | null): string | null {
  if (!date) {
    return null;
  }

  // Use UTC methods to avoid timezone issues
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  // Create new date with time at midnight UTC
  const dateWithZeroTime = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));

  return dateWithZeroTime.toISOString();
}
